<div class="card-container">
  <div class="title-wrapper">
    <h3>Background</h3>
  </div>
  <div class="subtitle-wrapper">
    <!-- Creator Flow Div -->
    @if (uploadImageFlow) {
      @if (imageProgress !== undefined) {
        <div class="progress-wrapper">
          <mat-progress-bar
            [mode]="!imageProgress ? 'query' : 'determinate'"
            [value]="imageProgress"
          ></mat-progress-bar>
          <p>
            Your image is uploading and processing, for large images this can take some time. Please do not leave this
            page until it is finished, your room is not yet created! If you do leave the page we will continue to
            process your image and it will be available in your asset library when complete.
          </p>
        </div>
      } @else {
        <div class="create-flow-wrapper">
          @if (createViewPortSelected) {
            <div class="create-flow-div">
              <div class="create-flow-title">Create Viewport Effects</div>
              <div class="create-flow-description">Select 3 images to create a parallax effect for the viewport.</div>
            </div>
          } @else if (createBackgroundSelected) {
            <div class="create-flow-div">
              <div class="create-flow-title">Upload Custom Background Image</div>
              <div class="create-flow-description">
                <span>Select an image file to become the background of your room.</span>
                <span>Note: make sure the image resolution is large enough for your room size.</span>
              </div>
            </div>
          }
          <div class="preview-card">
            <div class="preview-title">Background Preview</div>
            <div
              class="preview viewport-example"
              [ngStyle]="{ background: colorSelected ? color : '#adadac' }"
              [ngClass]="{
                'viewport-example': createViewPortSelected && !uploadImageFar && !uploadImageMid && !uploadImageNear,
                'background-example': createBackgroundSelected && !imageSelected,
                'background-parallax': createViewPortSelected && (uploadImageFar || uploadImageMid || uploadImageNear),
              }"
            >
              <img class="example-bubble first" src="/assets/images/example-bubble.svg" alt="Example bubble image" />
              <img class="example-bubble second" src="/assets/images/example-bubble-2.svg" alt="Example bubble image" />
              <img class="example-bubble third" src="/assets/images/example-bubble-3.svg" alt="Example bubble image" />
              @if (uploadImage) {
                <img src="{{ uploadImage.selectedImage }}" title="''" class="image-upload" />
              }

              @if (uploadImageFar) {
                <img class="far-layer" src="{{ uploadImageFar.selectedImage }}" alt="" />
              }

              @if (uploadImageMid) {
                <img class="mid-layer" src="{{ uploadImageMid.selectedImage }}" alt="" />
              }

              @if (uploadImageNear) {
                <img class="near-layer" src="{{ uploadImageNear.selectedImage }}" alt="" />
              }
            </div>
          </div>
        </div>
      }
    }

    <!-- Tab to Select Background or Create Background -->
    @if (imageProgress === undefined) {
      <mat-tab-group
        #tabGroup
        animationDuration="0ms"
        mat-stretch-tabs="false"
        class="background-create-tab"
        [(selectedIndex)]="selectedTab"
        (selectedTabChange)="selectedTabChange($event)"
      >
        <mat-tab>
          <ng-template matTabLabel>Background library</ng-template>
          <ng-template matTabContent>
            @if (showLoader) {
              <div class="loading-container">
                <app-loading></app-loading>
              </div>
            }
            <div>
              @for (categoryMap of newMappedCategory; track categoryMap) {
                <div class="category-row">
                  <div class="category-title">
                    <div class="category-name">{{ categoryMap.themeCategory }}</div>
                    @if (categoryMap.themeCategory !== 'Single color') {
                      <div class="category-size" (click)="expandRow($index)">
                        @if ($index === expandedRow) {
                          Show less
                        } @else {
                          Show All ({{ categoryMap.themesQnt }})
                        }
                      </div>
                    }
                  </div>
                  <div class="theme-card-row" [ngClass]="{ opened: $index === expandedRow }">
                    @for (theme of categoryMap.themes; track theme.socialThemeId) {
                      <div
                        class="theme-card"
                        (click)="selectTheme(theme)"
                        [ngClass]="{
                          selected: theme.socialThemeId === selectedThemeId,
                          color_card: categoryMap.themeCategory === 'Single color',
                        }"
                      >
                        <room-background-card
                          [theme]="theme"
                          [themeLabel]="getThemeLabel(categoryMap.themeCategory, theme.type)"
                        ></room-background-card>
                        @if (categoryMap.themeCategory === 'My Backgrounds') {
                          <button class="room-card-options" [matMenuTriggerFor]="menu">
                            <mat-icon>more_vert</mat-icon>
                          </button>
                          <mat-menu #menu="matMenu">
                            <button mat-menu-item (click)="startEditCustomTheme(theme)">Edit</button>
                            <button mat-menu-item (click)="deleteCustomTheme(theme.socialThemeId)">Delete</button>
                          </mat-menu>
                        }
                      </div>
                    }
                  </div>
                </div>
              }
            </div>
          </ng-template>
        </mat-tab>
        <mat-tab>
          <ng-template matTabLabel> {{ isEditing ? 'Editing a background' : 'Create a background' }} </ng-template>
          <ng-template matTabContent>
            <!-- Initial Create Background Flow -->
            @if (!uploadImageFlow) {
              <div class="create-background-content">
                <div class="select-color-div" [ngClass]="{ 'no-color': !colorSelected }">
                  <div class="div-title">Select a background color</div>
                  <div class="div-subtitle">Please select a background color</div>
                  <div class="div-color">
                    <span class="color-picked" (click)="openColorPickerDialog()" [style.background]="color"></span>
                    <span class="color-code">{{ color }}</span>
                  </div>
                </div>
                <div class="select-background-div" [ngClass]="{ disabled_div: !colorSelected }">
                  <div class="div-title">Select a background option</div>
                  <div class="div-card-options">
                    <div
                      class="card-option"
                      (click)="!colorSelected ? null : selectSimpleColorTheme()"
                      [ngClass]="{ option_selected: createSingleColorSelected }"
                    >
                      <div class="option-example" [ngStyle]="{ background: colorSelected ? color : '#adadac' }">
                        <img
                          class="example-bubble"
                          src="/assets/images/example-bubble.svg"
                          alt="Example bubble image"
                        />
                      </div>
                      <div class="option-info">
                        <div class="option-title">Color background</div>
                        <div class="option-points">
                          <span>Ready to go</span>
                          <span>No images</span>
                        </div>
                        <div class="option-description">
                          Create a new single color background, this is the most simple background of all, you can add
                          items later and interact with them
                        </div>
                      </div>
                    </div>
                    <div
                      class="card-option"
                      (click)="!colorSelected ? null : selectViewPortTheme()"
                      [ngClass]="{ option_selected: createViewPortSelected }"
                    >
                      <div
                        class="option-example viewport-example"
                        [ngStyle]="{ background: colorSelected ? color : '#adadac' }"
                      >
                        <img
                          class="example-bubble"
                          src="/assets/images/example-bubble.svg"
                          alt="Example bubble image"
                        />
                      </div>
                      <div class="option-info">
                        <div class="option-title">Viewport effects</div>
                        <div class="option-points">
                          <span>Items float</span>
                          <span>1-3 images</span>
                        </div>
                        <div class="option-description">
                          Select up to 3 images to create a parallax effect for the viewport
                        </div>
                      </div>
                    </div>
                    <div
                      class="card-option"
                      (click)="!colorSelected ? null : selectBackgroundTheme()"
                      [ngClass]="{ option_selected: createBackgroundSelected }"
                    >
                      <div
                        class="option-example background-example"
                        [ngStyle]="{ background: colorSelected ? color : '#adadac' }"
                      >
                        <img
                          class="example-bubble"
                          src="/assets/images/example-bubble.svg"
                          alt="Example bubble image"
                        />
                      </div>
                      <div class="option-info">
                        <div class="option-title">Image background</div>
                        <div class="option-points">
                          <span>True to grid</span>
                          <span>1 large image</span>
                        </div>
                        <div class="option-description">
                          Requires an image the size of the room but you will be able to add items and interact with
                          them in the same position in room than room creator
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            } @else {
              <!-- Create Background Flow Related to Viewport or Background Image -->
              <div class="create-background-steps">
                <div class="div-card-options">
                  <div class="card-option">
                    <div class="option-info">
                      <div>
                        <div class="step" [ngClass]="{ completed: true }"><mat-icon>check</mat-icon></div>
                      </div>
                      <div class="option-title">(Optional) Change background color</div>
                      <div class="option-description">Current background color</div>
                      <div class="option-description div-color">
                        <span class="color-picked" [style.background]="color"></span>
                        <span class="color-code">{{ color }}</span>
                      </div>
                      <div>
                        <button
                          data-testid="secondaryButton"
                          class="secondary-button"
                          (click)="openColorPickerDialog()"
                        >
                          Select Color
                        </button>
                      </div>
                    </div>
                  </div>
                  <div class="card-option">
                    <div class="option-info">
                      <div>
                        <div class="step" [ngClass]="{ completed: backgroundName.valid }">
                          @if (backgroundName.valid) {
                            <mat-icon>check</mat-icon>
                          } @else {
                            2
                          }
                        </div>
                      </div>
                      <div class="option-title">Create a name for the new background</div>
                      <div class="option-description">You will find it under this name on the background library</div>
                      <div class="option-description">
                        <input
                          class="background-name-input w-full p-18"
                          placeholder="Background name"
                          [formControl]="backgroundName"
                        />
                      </div>
                    </div>
                  </div>
                  <div class="card-option big-card">
                    @if (createViewPortSelected) {
                      <div>
                        <div
                          class="step"
                          [ngClass]="{ completed: uploadImageFar && uploadImageMid && uploadImageNear }"
                        >
                          @if (uploadImageFar && uploadImageMid && uploadImageNear) {
                            <mat-icon>check</mat-icon>
                          } @else {
                            3
                          }
                        </div>
                      </div>
                      <div class="option-info">
                        <div class="option-title">Add viewport effects images</div>
                        <div class="option-description">
                          Add 3 images to create a parallax effect on your participant’s viewport.
                        </div>
                        <div class="option-viewport">
                          <div class="viewport-layer">
                            <div class="viewport-check">
                              @if (uploadImageNear) {
                                <mat-icon>check</mat-icon>
                              }
                            </div>
                            <div class="viewport-description">Near image</div>
                            <div class="viewport-upload" (click)="openUploadImageDialog('Near')">
                              @if (uploadImageNear) {
                                change
                              } @else {
                                upload
                              }
                            </div>
                          </div>
                          <div class="viewport-layer">
                            <div class="viewport-check">
                              @if (uploadImageMid) {
                                <mat-icon>check</mat-icon>
                              }
                            </div>
                            <div class="viewport-description">Mid Image</div>
                            <div class="viewport-upload" (click)="openUploadImageDialog('Mid')">
                              @if (uploadImageMid) {
                                change
                              } @else {
                                upload
                              }
                            </div>
                          </div>
                          <div class="viewport-layer">
                            <div class="viewport-check">
                              @if (uploadImageFar) {
                                <mat-icon>check</mat-icon>
                              }
                            </div>
                            <div class="viewport-description">Far image</div>
                            <div class="viewport-upload" (click)="openUploadImageDialog('Far')">
                              @if (uploadImageFar) {
                                change
                              } @else {
                                upload
                              }
                            </div>
                          </div>
                        </div>
                      </div>
                    } @else if (createBackgroundSelected) {
                      <div>
                        <div class="step" [ngClass]="{ completed: imageSelected }">
                          @if (imageSelected) {
                            <mat-icon>check</mat-icon>
                          } @else {
                            3
                          }
                        </div>
                      </div>
                      <div class="option-info">
                        <div class="option-title">Add an image for your image background</div>
                        <div class="option-description">
                          Image should be at least the size of the room <br />
                          Current room size is {{ roomSize?.size }}x{{ roomSize?.size }} px
                        </div>
                        <div class="option-button">
                          <button
                            data-testid="uploadBtn"
                            class="upload-button"
                            (click)="openUploadImageDialog('Background')"
                          >
                            {{ uploadImage?.imageBytes ? 'Remove image' : 'Upload image' }}
                          </button>
                        </div>
                      </div>
                    }
                  </div>
                </div>
              </div>
            }
          </ng-template>
        </mat-tab>
      </mat-tab-group>
    }
  </div>

  <div class="footer-wrapper">
    @if (hasBackStepButton) {
      <button data-testid="secondaryButton" class="secondary-button" (click)="backStep()">Back</button>
    }

    @if (uploadImageFlow || isEditing) {
      <button data-testid="secondaryButton" class="secondary-button" (click)="cancelCreation()">Cancel</button>
    }

    <button data-testid="primaryButton" class="primary-button" [disabled]="disableNextBtn" (click)="nextStep()">
      {{ isCreateFlow ? 'Next' : 'Apply' }}
    </button>
  </div>
</div>
